<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/aNviNz/tc-custom/9781641086851.jpg?1718183001563" alt="This image is the cover for the book Out of Sight, Second Sight"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Out of Sight, Second Sight
      </h1>
      <p class="bookDescription body article font2">
        <p>Detective Gary Mitchell and psychic Dan Porter have a new cold case to tackle, and new leads to<br/> research in the hunt for Gary’s brother’s killer. Their life in Boston has settled into a comfortable<br/> rhythm.<br/><br/> But when forensic discoveries in a recent robbery gone wrong share similarities with their three-<br/> year-old cold case, all they can do is follow the evidence—and Dan’s gift—which leads them in<br/> an unexpected direction, way out of their comfort zone.<br/><br/> Gary and Dan find themselves in a shadowy world where they can trust no one, with unseen<br/> opponents who want them to back away from their investigation—and suddenly they’re in a race<br/> they have to win.<br/><br/> Because if they don’t, the consequences could be more far-reaching than they could possibly<br/> imagine.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        K.C. Wells
      </h2>
      
      <p class="authorDescription body article"><P>K.C. Wells lives on an island off the south coast of the UK, surrounded by natural beauty. She writes about men who love men, and can&rsquo;t even contemplate a life that doesn&rsquo;t include writing.</P><P>The rainbow rose tattoo on her back with the words &#39;Love is Love&#39; and &#39;Love Wins&#39; is her way of hoisting a flag. She plans to be writing about men in love - be it sweet and slow, hot or kinky - for a long while to come.</P><P>If you want to follow her exploits, you can sign up for her monthly newsletter: http://eepurl.com/cNKHlT</P><P>You can stalk &ndash; er, find &ndash; her in the following places:</P><P>Email: k.c.wells@btinternet.com</P><P>Facebook: <a href="http://www.facebook.com/KCWellsWorld">www.facebook.com/KCWellsWorld</a></P><P>KC&rsquo;s men In Love (my readers group): <a href="http://bit.ly/2hXL6wJ">http://bit.ly/2hXL6wJ</a></P><P>Amazon: <a href="https://www.amazon.com/K-C-Wells/e/B00AECQ1LQ">https://www.amazon.com/K-C-Wells/e/B00AECQ1LQ</a></P><P>Twitter: @K_C_Wells</P><P>Website: www.kcwellswrites.com</P><P>Instagram: <a href="http://www.instagram.com/k.c.wells">www.instagram.com/k.c.wells</a></P><P>BookBub: <a href="https://www.bookbub.com/authors/k-c-wells">https://www.bookbub.com/authors/k-c-wells</a></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      DSP Publications
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a4c3a50e